import React, { useEffect } from 'react';
import * as R from "ramda";
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { CreditCardTile } from './creditCardTile';
import { VirementTile } from './virementTile';
import { AddPaymentMethodModal } from '../modal/addPaymentMethodModal';
import { useStripe } from '@stripe/react-stripe-js';
import { GetPaymentIntentsSecretKey } from '../../../actions/user-api';
import toastConf from '../../../utils/toasterConfiguration';

export const MainPaymentMethods = ({ user, loadings }) => {
    const stripe = useStripe();
    const history = useHistory();
    let paymentMethod = user.paymentMethods.find(p => p.isDefault === true);
    const pi = new URLSearchParams(history.location.search).get("pi");

    useEffect(() =>
    {
        async function loadPaymentIntentsAsync() {
            if (!R.isNil(pi) && !R.isNil(stripe)) {
                await paymentIntents(user.id);
            }
        }
        loadPaymentIntentsAsync();

    }, [stripe, pi, user.id]);

    async function paymentIntents(id) {

        // if (R.isNil(stripe)) return;

        const piSecret = await GetPaymentIntentsSecretKey(id, pi);
        if (!piSecret) return;

        stripe.confirmCardPayment(piSecret.clientSecret)
            .then((result) => {
                if (result.error) {
                    toast.error(result.error.message, toastConf);
                } else {
                    toast.success("Paiement avec succès!", toastConf);
                }
            });
    }


    return (
        <React.Fragment >
            {
                user.paymentMethods.length > 0 ?
                    user.paymentMethods[0].type.toLowerCase() === "card" ?
                        <CreditCardTile paymentMethod={paymentMethod} user={user} />
                        :
                        <VirementTile paymentMethod={paymentMethod} user={user} />
                    :
                    <button className="btn btn-white-secondary text-secondary shadow-xs mb-2" data-toggle="modal" data-target="#payment">Ajouter un mode de paiement</button>
            }
            {
                // user.paymentMethods.length > 0 ?
                //     <button className="btn btn-white-secondary text-secondary shadow-xs mb-2" data-toggle="modal" data-target="#payment">Remplacer la méthode de paiement</button>
                // :
                //     ''
            }
            <AddPaymentMethodModal user={user} loadings={loadings} />
        </React.Fragment>
    );
};